import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const UserPage = lazy(() => import('src/pages/user/user'));
const UserProfilePage = lazy(() => import('src/pages/user/profile'));
const UserPerformancePage = lazy(() => import('src/pages/user/user-performance'));

// ----------------------------------------------------------------------

export const userRoutes: RouteObject[] = [
  {
    path: 'user',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <UserPage />, index: true },
      { path: 'profile', element: <UserProfilePage /> },
      { path: ':userId/performance', element: <UserPerformancePage /> },
    ],
  },
];
